export default __webpack_public_path__ + "static/logo-feeldoog-8a849e50ad7dc61bffe0d8cb0cfe2e4e.png";